import CurrentUser from 'auth/CurrentUser';
import ZendeskWidget, { openWidget, useZendeskChatStatus } from 'coaching/components/ZendeskWidget';
import Icon from 'components/Icon';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import React, { useState, useEffect } from 'react';
import LoadingIndicator from 'components/LoadingIndicator';

declare global {
  interface Window {
    AdaBot?: {
      show: () => void;
    };
  }
}

const SupportChat = ({ liveAgent = false }: { liveAgent: boolean }): JSX.Element => {
  const [loading, setLoading] = useState(true);
  const [isChatOnline] = useZendeskChatStatus();
  const featureFlag = CurrentUser.getUser()?.hasFeature('2021.jun.saas.live_support_chat');
  const zendesk = liveAgent && isChatOnline && featureFlag;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <>
      <ZendeskWidget />

      {loading ? (
        <LoadingIndicator align="center" />
      ) : zendesk ? (
        <MediaObject center gutter="small">
          <Icon name="replies" size="large" />
          <Text>
            <Link onClick={openWidget} eventElementName="SupportDialog-actions-link">
              <MediaObject center gutter="xxsmall">
                <Text weight="semibold">Chat with a live agent</Text>
                <Text size="xxxsmall">
                  <Icon name="chevron-right" size="inherit" />
                </Text>
              </MediaObject>
            </Link>
            <Text size="xxsmall" color="graphite">
              Chat with a Remind team member Monday through Friday, 6am-6pm PT.
            </Text>
          </Text>
        </MediaObject>
      ) : (
        <MediaObject center gutter="small">
          <Icon name="replies" size="large" />
          <Text>
            <div>
              <Link
                onClick={() => window.AdaBot?.show()}
                disabled={!window.AdaBot}
                tooltip={!window.AdaBot && 'Chat bot could not be loaded'}
                tooltipPlacement="top"
                eventElementName="SupportDialog-actions-link">
                <MediaObject center gutter="xxsmall">
                  <Text weight="semibold">Chat now</Text>
                  <Text size="xxxsmall">
                    <Icon name="chevron-right" size="inherit" />
                  </Text>
                </MediaObject>
              </Link>
            </div>
            <Text size="xxsmall" color="graphite">
              Get immediate answers from our support bot, Richard
            </Text>
          </Text>
        </MediaObject>
      )}
    </>
  );
};

export default SupportChat;
